import { useEffect, useState } from "react";
import { ShoppingBasket } from "lucide-react";
import { Logo } from "./Logo";
import { scrollToId } from "../lib/scroll";
import { inr } from "../data/menu";

const LINKS = [
  { id: "home", label: "Home", testid: "nav-link-home" },
  { id: "menu", label: "Menu / Order Food", testid: "nav-link-menu" },
  { id: "contact", label: "Contact", testid: "nav-link-contact" },
];

export const Header = ({ count, subtotal, onCartOpen }) => {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const fn = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", fn, { passive: true });
    return () => window.removeEventListener("scroll", fn);
  }, []);

  return (
    <header
      className={`sticky top-0 z-50 bg-[#FFFDF8]/90 backdrop-blur-md border-b border-[#EFE6DC] transition-shadow duration-300 ${
        scrolled ? "shadow-[0_10px_30px_-5px_rgba(61,35,20,0.08)]" : ""
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-[72px] flex items-center justify-between gap-3">
        <button onClick={() => scrollToId("home")} className="shrink-0" aria-label="Harshi's Kitchen home">
          <Logo />
        </button>
        <nav className="hidden md:flex items-center gap-8">
          {LINKS.map((l) => (
            <button
              key={l.id}
              data-testid={l.testid}
              onClick={() => scrollToId(l.id)}
              className="text-sm font-medium text-[#5A4232] hover:text-[#D86A7A] transition-colors duration-300 tracking-wide"
            >
              {l.label}
            </button>
          ))}
        </nav>
        <button
          data-testid="cart-toggle-button"
          onClick={onCartOpen}
          className="relative flex items-center gap-2 rounded-full bg-[#D86A7A] hover:bg-[#C85265] text-white pl-4 pr-5 py-2.5 text-sm font-semibold transition-colors duration-300 shadow-[0_8px_20px_-6px_rgba(216,106,122,0.5)]"
        >
          <ShoppingBasket size={18} />
          <span className="hidden sm:inline">{count > 0 ? inr(subtotal) : "Cart"}</span>
          <span
            data-testid="cart-item-count-badge"
            className="absolute -top-1.5 -right-1.5 min-w-[22px] h-[22px] px-1 rounded-full bg-[#3A6B4C] text-white text-xs font-bold flex items-center justify-center border-2 border-[#FFFDF8]"
          >
            {count}
          </span>
        </button>
      </div>
    </header>
  );
};
